import { Link, useLocation } from "react-router-dom";
import { AchievementNotifier } from "@/components/achievements/AchievementNotifier";
import { SiteHeader, type SecondaryNavItem } from "@/components/layout/SiteHeader";
import { AdFreeUpsell } from "@/components/ads/AdFreeUpsell";

const TIPPING_NAV: SecondaryNavItem[] = [
  {
    to: "/tipping/dashboard",
    label: "Dashboard",
    activePrefixes: ["/tipping/dashboard", "/tipping/rounds"],
  },
  { to: "/tipping/history", label: "History" },
  { to: "/tipping/leaderboard", label: "Leaderboard" },
  { to: "/tipping/competitions", label: "Competitions" },
  { to: "/tipping/achievements", label: "Badges" },
  {
    to: "/tipping/analytics",
    label: "Tipping Stats",
  },
  {
    to: "/tipping/player-stats",
    label: "Player Stats",
    activePrefixes: [
      "/tipping/player-stats",
      "/tipping/games",
      "/tipping/players",
      "/tipping/clubs",
    ],
  },
];

export function AppShell({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const showTippingNav = pathname.startsWith("/tipping");

  return (
    <div className="min-h-screen bg-background">
      <SiteHeader
        secondaryLabel="Tipping navigation"
        secondaryNav={showTippingNav ? TIPPING_NAV : undefined}
      />

      <main id="main-content" className="mx-auto max-w-7xl px-4 py-6">
        {children}
        <AdFreeUpsell className="mt-10" />
      </main>

      <footer className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 pb-8 text-xs text-muted-foreground">
        <span>© {new Date().getFullYear()} Tackle Four</span>
        <Link className="hover:text-foreground" to="/privacy">
          Privacy
        </Link>
      </footer>

      <AchievementNotifier />
    </div>
  );
}
